import {connect} from '@modifi/redux'

import SeoHeader, {SeoHeaderProps} from './SeoHeader'

const mapStateToProps = (state: Record<string, any>): Pick<SeoHeaderProps, 'pathname'> => ({
  pathname: state?.router?.location?.pathname,
})

export default connect(mapStateToProps)(SeoHeader)
